'use client';

import React from 'react';
import { Tooltip } from '@/app/components/Tooltip';
import { TooltipWrapper } from '@/app/components/Tooltip/components/TooltipWrapper';

export function CardWithTooltip({
  show,
  content,
  children,
}: {
  show: boolean;
  content: React.ReactNode;
  children: React.ReactElement;
}) {
  if (!show) return children;

  return (
    <Tooltip placement="top" isVisible content={<TooltipWrapper>{content}</TooltipWrapper>}>
      <div className="w-full">{children}</div>
    </Tooltip>
  );
}
